import { Link } from 'react-router-dom';
import { React, useEffect, useState } from 'react';
import { retrieveToken } from '../../../hooks/use-token';
import { listaArquivosAula } from '../../../api/aluno';

const AssistirMaisTardeTable = () => {
  
  const [meusArquivos, setMeusArquivos] = useState(null);
  
  useEffect(() => {
    
    const tokenApi = retrieveToken();
    
    listaArquivosAula(tokenApi).then(function(result) {
      setMeusArquivos(result);
    });
    
  }, []);
  
  return (
    <div className="table-content table-responsive" style={{marginTop: 35}}>
    <table className="table">
    <thead>
    <tr>
    <th className="product-thumbnail">Imagem</th>
    <th className="cart-product-name">Nome</th>
    <th className="cart-product-name">Acessar</th>
    </tr>
    </thead>
    <tbody>
    {meusArquivos != null && meusArquivos.map((arquivo, index) => (
      <tr key={index}>
      <td>
      <Link to={`/modulo/${arquivo.aula.modulo_fk}/aula/assistir/${arquivo.aula.cd_aula}`}>
        <img src={"https://v1.profaprizattera.com.br/uploads/aula/" + arquivo.aula.file} alt="" width="75" />
      </Link>
      </td>
      <td>{arquivo.aula.titulo}</td>
      <td><a className="e-btn" href={`/modulo/${arquivo.aula.modulo_fk}/aula/assistir/${arquivo.aula.cd_aula}`}>Assistir</a></td>
      </tr>
      ))}
      </tbody>
      </table>
      </div>
      );
      
    };
    
    export default AssistirMaisTardeTable;